import { Injectable } from '@angular/core';
import {retryWithBackoff} from "../../libs/rxjs/retryWithBackoff";
import {map} from "rxjs/operators";
import {StoreSelectorsService} from "./store-selectors.service";
import {ToastrService} from "ngx-toastr";
import {HttpClient} from "@angular/common/http";
import {TranslocoService} from "@ngneat/transloco";
import {Observable, shareReplay} from "rxjs";
import {traverseTree} from "../common";


type VideoNode = {
    helpName?: string;
    name?: string;
    children?: VideoNode[];
    [key: string]: any;
};

@Injectable({
  providedIn: 'root'
})

export class TutorialsService {
    data$;
    videoIds = {};

    constructor(private _http: HttpClient,
                private translocoService: TranslocoService,
                private storeSelector: StoreSelectorsService,
                private toastr: ToastrService) {

    }


    getData(): Observable<any> {
        if (this.data$ == null) {
            const local = this.translocoService.getActiveLang();
            const url = `./assets/vi18n/${local}.json?${Math.random()}`;
            this.data$ = this._http.request("GET", url, {responseType: "json"})
                .pipe(
                    retryWithBackoff(url, this.storeSelector, this.toastr),
                    map(a => {
                        const b = JSON.stringify(a).replace(/text/ig, 'name').replace(/icon/ig, 'iconname').replace(/Children/ig, 'children');
                        const data = JSON.parse(b);

                        traverseTree(data, (x, y, n) => {
                            if (x == 'videoid') {
                                if (this.videoIds[n.videoid]!=null) {
                                    console.warn("duplicate=" + n.videoid);
                                }
                                this.videoIds[n.videoid] = n;
                            }
                        });

                        return data;
                    }),
                    shareReplay(1)
                );
        }
        return this.data$;
    }


    extractVideoItems(node: VideoNode, currentPath: string = ''): { helpName: string; text: string; path: string }[] {
        const result: { helpName: string; text: string; path: string }[] = [];

        // Build the updated path
        const newPath = node.name ? (currentPath ? `${currentPath} > ${node.name}` : node.name) : currentPath;

        // If this node has a videoid, add it to the result
        if (node.videoid && node.name) {
            result.push({
                helpName: node.videoid,
                text: node.name,
                path: newPath
            });
        }

        // Recurse into children
        if (node.children && Array.isArray(node.children)) {
            for (const child of node.children) {
                result.push(...this.extractVideoItems(child, newPath));
            }
        }

        return result;
    }


}
